/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    a: "a",
    span: "span",
    p: "p",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "abstract"
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#abstract"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), "Abstract"), "\n", React.createElement(_components.p, null, "Document capturing with smartphone cameras is performed increasingly often in our daily lives. However, our user study results (n=10) showed that more than 80% of landscape tasks had incorrect orientations. To solve this problem, we systematically analyzed user behavior of document capturing and proposed a novel solution called ScanShot that detects document capturing moments to help users correct the orientation errors. ScanShot tracks the gravity direction to capture document capturing moments, analyzes logged gyroscope data to automatically update orientation changes, and provides visual feedback of the inferred orientation for manual correction. Our user study results (n=20) confirmed that capturing moments can be recognized with accuracy of 97.5%, our update mechanism can reduce the orientation errors by 59 percentage points."), "\n", React.createElement("iframe", {
    className: "w-full aspect-video",
    src: "https://www.youtube.com/embed/_nB2AdnlAoc?si=4hfjOhuJu4o2KHP4",
    title: "ScanShot: Detecting Document Capture Moments and Correcting Device Orientation",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: true
  }), "\n", React.createElement(_components.h1, {
    id: "links"
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#links"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), "Links"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://drive.google.com/uc?export=download&id=1qQk8Mcldrl12S3aQrkKSCdEmHvfddOXS",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Paper")), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://drive.google.com/uc?export=download&id=1Om2OhaHXEjrXJsC12y5LvNZHhohDutnU",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Slide")), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
